import {
    computed, SetupContext, unref, Ref,
} from 'vue';
import { MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
import { ITourProduct } from '@entities/tourProduct';
import { IMapForSearchDataGetters } from '@ve/pages/serp/store';
import { NAMESPACE as MAP_FOR_SEARCH_DATA } from '@ve/pages/serp/store/SearchDataStore';
import { useGetters, useState } from 'vuex-composition-helpers';
import _ from 'underscore';

const filtersMappingStoreName = 'mapForFilters';

export default ({ emit }: SetupContext) => {
    const {
        isExclusive,
        products,
        productType,
        directFlight,
    } = useState<MapForFiltersState>(filtersMappingStoreName, ['isExclusive', 'warranted', 'products', 'productType', 'directFlight']);

    const {
        isPairOfDepartureCityAndArrivalCountryAreValid,
    } = useGetters<IMapForSearchDataGetters>(MAP_FOR_SEARCH_DATA, ['isPairOfDepartureCityAndArrivalCountryAreValid']);

    const numOfSelected = computed(() => {
        let numOfSelectedFilters = +unref(isExclusive);
        numOfSelectedFilters += unref(directFlight) ? 1 : 0;
        return numOfSelectedFilters;
    });

    const selectedFiltersText = computed(() => {
        let text = 'Доп. параметры';
        if (unref(numOfSelected)) {
            text += `: ${unref(numOfSelected)}`;
        }
        return text;
    });


    const isExclusiveFilterShow = computed(() => unref(isExclusive) || !!_.find(unref(products), (product) => product.isExclusive));

    const isProductTypeAllOrTourOffer = computed(() => unref(productType) === 'all' || unref(productType) === 'tourOffer');

    const directFlightFilterShow = computed(() => unref(isProductTypeAllOrTourOffer) && unref(isPairOfDepartureCityAndArrivalCountryAreValid))

    const additionalFiltersHidden = computed(() => unref(productType) === 'hotelOffer' || unref(productType) === 'railwayTour');

    const isExclusiveChanged = (isExclusiveValue: boolean) => {
        emit('is-exclusive-filter-changed', isExclusiveValue);
    };

    const directFlightChanged = (directFlightValue: boolean) => {
        emit('direct-flight-changed', directFlightValue);
    };
    return {
        additionalFiltersHidden,
        selectedFiltersText,
        isExclusiveFilterShow,
        isProductTypeAllOrTourOffer,
        isExclusiveChanged,
        directFlightChanged,
        isExclusiveSelected: isExclusive,
        directFlightSelected: directFlight,
        directFlightFilterShow,
        numOfSelected,
    };
};